import { Component } from '@angular/core';

@Component({
  selector: 'vl-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent {

}
